<template>
  <div class="flex-box">
    <p class="title">{{title}}</p>
    <BdoProgress v-if="stepShow" :step="step" :total="total"></BdoProgress>
  </div>
</template>

<script>
  export default {
    name: "FormTitle",

    props: {
      title: String,

      stepShow: {
        type: Boolean,
        default: true
      },

      step: {
        type: [String, Number],
        default: 1
      },

      total: {
        type: [String, Number],
        default: 12
      },
    }
  }
</script>

<style lang="scss" scoped>
  .flex-box {
    justify-content: space-between;
  }
</style>